import dayjs from 'dayjs';
import { useState } from 'react';

export default function useDateRange() {
  const [dateValue, setDateValue] = useState([
    dayjs().subtract(1, 'day'),
    dayjs().subtract(1, 'day'),
  ]);
  const [dateTempValue, setDateTempValue] = useState([null, null]);

  return {
    dateValue,
    setDateValue,
    dateTempValue,
    setDateTempValue,
  };
}
